import React from "react";
import { _t } from "app/i18n/i18n";
import { Table } from "react-bootstrap";
import { useJSFetchPublications } from "pages/redesign/publications/api/direct/useJSFetchPublications";
import { LoadingSpinner } from "lib/Spinner";
import styles from "./SubscriptionsTopReports.module.scss";
import {
  formatPublicationDate,
  generateTagsRequest,
  injectTxCatFilters,
  useCreateFilterRequest,
} from "./SubscriptionsTopReports.helpers";
import { useQueryParams } from "../../../lib/hooks/useQueryParams";

function SubscriptionsTopReports({
  selectedSubscriptionTags,
  selectedLanguages,
  selectedPub,
  isSubscriptionFromPillsBar,
}) {
  const qs = useQueryParams();
  const filters = useCreateFilterRequest(
    selectedSubscriptionTags,
    qs,
    selectedLanguages,
    selectedPub,
    isSubscriptionFromPillsBar,
  );

  const finalFilters = injectTxCatFilters(filters, selectedPub, isSubscriptionFromPillsBar, selectedSubscriptionTags);

  const tagsRequest = generateTagsRequest(finalFilters);
  const [pubs, isLoading] = useJSFetchPublications(tagsRequest, true, false) || [];

  if (isLoading) return <LoadingSpinner className="mx-auto pt-5 pb-5" />;

  return (
    <div className={styles.wrapper}>
      <Table bordered striped responsive className={styles.table}>
        <thead>
          <tr>
            <th className={styles.dateHeader}>{_t("recent-publications-date")}</th>
            <th>{_t("recent-publications-title")}</th>
          </tr>
        </thead>
        <tbody>
          {pubs.map((item, index) => {
            const key = `${item.title}-${index}`;
            const formattedDate = formatPublicationDate(item.publicationDate);

            return (
              <tr key={key}>
                <td className={styles.date} data-label="Date">
                  <span className={styles.dateText}>{formattedDate}</span>
                </td>
                <td data-label="Publications">
                  <a className={`${styles.pubLink} text-primary`} href={item.pubUrl} target="_blank" rel="noreferrer">
                    {item.title}
                  </a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}

export default SubscriptionsTopReports;
